<div class="documents-header mt-2 mb-5">
  <h5 class="font-weight-bold mb-0">{{ 'ProjectsDashboard.summary.documents.title' | translate }}</h5>

  <app-button
    (onClick)="createEntryWithAllDocumentTypes()"
    [config]="{
      size: ButtonSize.LARGE,
      type: ButtonTypes.NEW_PRIMARY_BLUE,
      text: ('ProjectsDashboard.summary.documents.add' | translate),
      prependSrc: './assets/img/ic-plus-add.svg'
    }"
  />
</div>

<div class="documents-card">
  <div class="documents-columns">
    @for (group of documentGroups(); track group.boxName) {
      <div class="documents-column">
        <div class="documents-column__header">
          <div class="documents-actions">
            <new-toggle-checkbox-v2
              [label]="'ProjectsDashboard.summary.documents.showEmpty' | translate"
              [ngModel]="isGroupExpanded(group.boxName)"
              (onValueChange)="toggleGroupVisibility(group.boxName, $event)"
            />
          </div>
        </div>

        <div class="documents-group">
          <div class="documents-group__divider">
            <span>{{ group.title | translate }}</span>
          </div>

          <div class="documents-group__info">
            {{ group.description | translate }}
          </div>
        </div>

        <div class="documents-sections">
          @if (!group.hasDocuments) {
            <div class="documents-empty-state">
              {{ 'ProjectsDashboard.summary.documents.emptyState' | translate }}
            </div>
          } @else {
            @for (section of group.sections; track section.type) {
              <div class="documents-section">
                <button
                  type="button"
                  class="documents-section__header documents-section__header--button"
                  (click)="toggleSectionVisibility(group.boxName, section.type)"
                >
                  <div class="documents-section__title">
                    {{ section.translation | translate: section.translationParams }}
                  </div>

                  <svg-icon
                    class="documents-section__arrow"
                    [class.documents-section__arrow--opened]="isSectionExpanded(group.boxName, section.type)"
                    src="./assets/img/ic-arrow-down-black.svg"
                  />
                </button>

                @if (isSectionExpanded(group.boxName, section.type)) {
                  <div class="documents-items">
                    @for (item of section.items; track item.id) {
                      <div class="documents-item">
                        <div class="documents-item__header">
                          <div class="documents-item__title">
                            {{ item.name }}
                          </div>

                          <div class="documents-item__meta">
                            <span>{{ item.created | dateTimeFormat }}</span>

                            <button
                              type="button"
                              class="documents-item__icon-btn"
                              (click)="editEntry(item.id)"
                            >
                              <svg-icon class="documents-item__icon" src="./assets/img/ic-edit-v2.svg" />
                            </button>

                            <button
                              type="button"
                              class="documents-item__icon-btn"
                              [disabled]="isDeleting(item.id)"
                              (click)="confirmDelete(item.entry)"
                            >
                              <svg-icon
                                class="documents-item__icon"
                                src="./assets/img/ic-trash-blue-v2.svg"
                              />
                            </button>
                          </div>
                        </div>

                        <div class="documents-item__content">
                          <div class="documents-item__description" [innerHTML]="item.description"></div>

                          @if (item.previewAttachments.length) {
                            <div
                              class="documents-item__images-slider"
                              [class.documents-item__images-slider--overflowing]="
                                showSliderNavigation(item.id)
                              "
                            >
                              <swiper
                                #imagesSwiper
                                [config]="imagesSliderConfig"
                                (swiper)="initImageSwiper(item.id, $event)"
                              >
                                <ng-template
                                  *ngFor="
                                    let attachment of item.previewAttachments;
                                    trackBy: attachmentTrackBy
                                  "
                                  swiperSlide
                                >
                                  @if (attachment.isImage) {
                                    <div
                                      class="documents-item__attachment-card-wrap mt-2"
                                      (mouseenter)="onAttachmentMouseEnter(attachment.id)"
                                      (mouseleave)="onAttachmentMouseLeave(attachment.id)"
                                    >
                                      <a
                                        class="documents-item__attachment-card"
                                        [href]="attachment.file | authFile"
                                        [attr.data-fancybox]="getGalleryId(item.id)"
                                      >
                                        <span class="documents-item__attachment-card-preview">
                                          <img
                                            class="documents-item__attachment-card-file documents-item__attachment-card-file--image"
                                            [src]="attachment.file | authFile"
                                            [alt]="attachment.name"
                                          />
                                        </span>

                                        <span class="documents-item__attachment-card-data">
                                          <span class="documents-item__attachment-card-name">
                                            {{ attachment.name }}
                                          </span>

                                          <span class="documents-item__attachment-card-type">
                                            {{ attachment.customType }}
                                          </span>
                                        </span>
                                      </a>

                                      @if (isAttachmentHovered(attachment.id)) {
                                        <div class="documents-item__attachment-actions">
                                          <button
                                            type="button"
                                            class="documents-item__attachment-action documents-item__attachment-action--edit"
                                            (click)="onAttachmentEditClick($event, item.id, attachment)"
                                          >
                                            <svg-icon src="./assets/img/ic-edit-v2.svg" />
                                          </button>

                                          <button
                                            type="button"
                                            class="documents-item__attachment-action documents-item__attachment-action--delete"
                                            [disabled]="isAttachmentDeleting(attachment.id)"
                                            (click)="confirmDeleteAttachment($event, item.id, attachment)"
                                          >
                                            <svg-icon src="/assets/img/ic-trash-outline-red.svg" />
                                          </button>
                                        </div>
                                      }
                                    </div>
                                  } @else if (attachment.isPdf) {
                                    <div
                                      class="documents-item__attachment-card-wrap mt-2"
                                      (mouseenter)="onAttachmentMouseEnter(attachment.id)"
                                      (mouseleave)="onAttachmentMouseLeave(attachment.id)"
                                    >
                                      <a
                                        class="documents-item__attachment-card"
                                        [href]="attachment.file | authFile"
                                        [attr.data-fancybox]="getGalleryId(item.id)"
                                      >
                                        <span class="documents-item__attachment-card-preview">
                                          <svg-icon
                                            class="documents-item__attachment-card-file documents-item__attachment-card-file--pdf"
                                            src="./assets/img/ic-pdf.svg"
                                          />
                                        </span>

                                        <span class="documents-item__attachment-card-data">
                                          <span class="documents-item__attachment-card-name">
                                            {{ attachment.name }}
                                          </span>

                                          <span class="documents-item__attachment-card-type">
                                            {{ attachment.customType }}
                                          </span>
                                        </span>
                                      </a>

                                      @if (isAttachmentHovered(attachment.id)) {
                                        <div class="documents-item__attachment-actions">
                                          <button
                                            type="button"
                                            class="documents-item__attachment-action documents-item__attachment-action--edit"
                                            (click)="onAttachmentEditClick($event, item.id, attachment)"
                                          >
                                            <svg-icon src="./assets/img/ic-edit-v2.svg" />
                                          </button>

                                          <button
                                            type="button"
                                            class="documents-item__attachment-action documents-item__attachment-action--delete"
                                            [disabled]="isAttachmentDeleting(attachment.id)"
                                            (click)="confirmDeleteAttachment($event, item.id, attachment)"
                                          >
                                            <svg-icon src="/assets/img/ic-trash-outline-red.svg" />
                                          </button>
                                        </div>
                                      }
                                    </div>
                                  } @else {
                                    <app-attachment-file-preview
                                      class="documents-item__file mt-2"
                                      [token]="getAttachmentToken()"
                                      [file]="attachment"
                                    />
                                  }
                                </ng-template>
                              </swiper>

                              @if (showSliderNavigation(item.id)) {
                                <button
                                  type="button"
                                  class="documents-item__slider-nav documents-item__slider-nav--prev"
                                  (click)="slidePrev(imagesSwiper)"
                                >
                                  <svg-icon src="./assets/img/ic-arrow-right-black.svg" />
                                </button>

                                <button
                                  type="button"
                                  class="documents-item__slider-nav documents-item__slider-nav--next"
                                  (click)="slideNext(imagesSwiper)"
                                >
                                  <svg-icon src="./assets/img/ic-arrow-right-black.svg" />
                                </button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
